import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useT } from "@/i18n";

export const COUNTRY_CODES = [
  "AE", "AF", "AL", "AM", "AO", "AR", "AT", "AU", "AZ", "BA", "BD", "BE", "BG", "BH", "BR", "BY",
  "CA", "CH", "CL", "CM", "CN", "CO", "CR", "CY", "CZ", "DE", "DK", "DO", "DZ", "EC", "EE", "EG",
  "ES", "ET", "FI", "FR", "GB", "GE", "GH", "GR", "GT", "HK", "HR", "HU", "ID", "IE", "IL", "IN",
  "IQ", "IS", "IT", "JO", "JP", "KE", "KH", "KR", "KW", "KZ", "LB", "LK", "LT", "LU", "LV", "LY",
  "MA", "MD", "ME", "MK", "MT", "MU", "MV", "MX", "MY", "NG", "NL", "NO", "NP", "NZ", "OM", "PA",
  "PE", "PH", "PK", "PL", "PT", "QA", "RO", "RS", "RU", "SA", "SE", "SG", "SI", "SK", "SN", "TH",
  "TN", "TR", "TW", "TZ", "UA", "UG", "US", "UY", "UZ", "VN", "ZA", "ZW",
] as const;

export function CountrySelect({
  value,
  onChange,
  id,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  placeholder?: string;
}) {
  const { t } = useT();
  return (
    <Select {...(value ? { value } : {})} onValueChange={onChange}>
      <SelectTrigger id={id}>
        <SelectValue placeholder={placeholder ?? t("shell.country.placeholder")} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {COUNTRY_CODES.map((code) => (
          <SelectItem key={code} value={code}>
            {t(`shell.country.${code}` as never)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
